module.exports = __webpack_public_path__ + "static/media/typewriter.69e026c9.svg";